// Native
import {Injectable} from '@angular/core';

@Injectable()
export class LoaderService {

  constructor() { }

  public isLoading: boolean = true;
  public state: string = 'show';

  show(state?: string) {
    this.state = state || 'show';

    this.isLoading = true;
  }

  hide(state?: string) {
    this.state = state || 'fade';

    this.isLoading = false;
  }

  toggle(showState?: string, hideState?: string) {
    let states = {
      show: showState || 'show',
      hide: hideState || 'fade'
    };

    this.state = states[this.isLoading ? 'hide' : 'show'];

    this.isLoading = !this.isLoading;
  }
}
